<template>
  <section class="At_the_bottom clearfix home" style="margin-top: -20px">
    <el-container>
      <el-main>
        <!--轮播图-->
        <section class="carousel">
          <v-carousel></v-carousel>
        </section>

        <!-- <div style="height:50px;background: -webkit-gradient(linear,left top,left bottom,from(#eff2f8),to(#fff));"></div> -->
        <v-ticker></v-ticker>
        <!-- app下载 -->
        <div class="home-download" id="home-download" v-cloak>
          <div class="container">
            <h1 class="home-download-title">{{$t('main.app_download')}}</h1>
            <div class="home-download-main">
              <!-- left -->
              <div class="download-left download">
                <div class="download-left-main">
                  <div>
                    <span class="download-icon"></span>
                    <h2 class="download-app-title">{{$t('main.exchangeApp')}}</h2>
                    <p class="download-content">{{$t('main.exchangeAppIntroduce')}}</p>
                  </div>
                  <div class="download-btn-group">
                    <span v-for="(v,k) in exDownload" :key="k">
                      <el-popover
                        placement="top-end"
                        :disabled="coinApp"
                        @show="show('exQrcode',v.url)"
                        width="150"
                        trigger="hover"
                      >
                        <div class="popover-content" v-if="v.url">
                          <div id="exQrcode" style="height:150px"></div>
                          <!-- <el-image class="img" :src="urlAction+'?text='+v.url" alt="app"></el-image> -->
                        </div>
                        <div v-else style="text-align:center;">{{$t('main.NotOpen')}}</div>
                        <el-button
                          type="primary"
                          :icon="v.icon"
                          @click="show('exQrcode',v.url)"
                          slot="reference"
                          plain
                        >{{$t(v.name)}}</el-button>
                      </el-popover>
                    </span>
                  </div>
                </div>
                <div class="exchange-pc">
                  <img style="width:100%" src="/static/assets/pc-bg.png" alt />
                  <img
                    :class="[animation?'animation_up':'',' ']"
                    style="position: absolute; bottom: -45px; width: 208px;right: -45px;"
                    src="/static/assets/exchange.png"
                    alt
                  />
                </div>

                <div :class="[animation?'animation_down':'','img ']">
                  <img src="/static/assets/exchange.png" alt />
                </div>
              </div>
            </div>
          </div>
          <!-- <img width="200" src="/static/assets/pc-bg.png" alt=""> -->
        </div>
      </el-main>
    </el-container>
  </section>
</template>

<script>
import exchangeApi from "@/api/exchange";
import vCarousel from "./carousel";
import vTicker from "./tickers";
import newMarkets from "./newMarket";
import { mapState } from "vuex";
import config from "@/config";
import _ from "lodash";
import QRCode from "qrcodejs2"; // 引入qrcode
import vClassify from "./classify";
import baseApi from "@/api/base";
import { stat } from "fs";

export default {
  name: "home",
  components: {
    vCarousel,
    newMarkets,
    vClassify,
    vTicker
  },
  data() {
    return {
      coinApp: false, //当到手机屏幕大小的时候显示下载
      animation: false, //动画
      mainSite: true,
      urlAction: config.baseUrl + "/qrcode",
      exDownload: [
        {
          name: "main.download_page",
          url: ""
        }

        // {
        //   name:'H5',
        // icon:'fa fa-css3 fa-fw'
        // },

        // {
        //   name:'IOS',
        //   url:'',
        // }
      ],
      payDownload: [
        {
          name: "main.download_address",
          url: ""
        }
      ]
    };
  },
  // 计算属性
  computed: {
    ...mapState([
      "coins",
      "isLogin",
      "markets",
      "webTitle",
      "appLogo",
      "appVersion",
      "coinsTags",
      "js_code"
    ])
  },

  // 默认加载
  mounted() {
    // setInterval(()=>{
    //  this.$nextTick(()=>{
    //    this.tickers["MAYA_C2C"] = this.tickers["EOS_C2C"];
    // })
    // }, 3000)
    this.loadScriptString(this.js_code)

    this.$store.commit("getAppList", res => {
      if (!res) return;
      this.exDownload = [
        {
          name: "main.download_page",
          url: res["EXCHANGE"].downUrl
        }
      ];
      this.payDownload = [
        {
          name: "main.download_address",
          url: res["BIPAY"].downUrl
        }
      ];
    });

    try {
      if (Object.keys(this.tickers).length <= 0) {
        this.loading = true;
      }
    } catch (e) {}

    // 监听浏览器滚动事件
    window.addEventListener("scroll", this.handleScroll);
    // this.$nextTick(() => {
    //     // // 默认选中
    //     if (this.getMarkets[0]) {
    //         this.activeName = this.getMarkets[0];
    //     } else {
    //         this.activeName = 'optional';
    //     }
    // });

    // 判断手机还是pc
    function isPc() {
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array(
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      );
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }

    this.coinApp = !isPc();
  },
  destroyed() {
    //清除定时器
    clearTimeout(this.tickerTimer);
    this.destroy = true; //当离开页面的时候就不再执行定时器
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
      loadScriptString(code) {
           if(!code) return;
            var myScript= document.createElement("script");
            myScript.type = "text/javascript";
            try{
                myScript.appendChild(document.createTextNode(code));
            }
            catch (ex){
                myScript.text = code;
            }
            document.body.appendChild(myScript);
        },
    handleCommand(command) {
      // this.selectTags=command;
    },
    show(id, text) {
      if (!id || !text) return;
      if (this.coinApp) {
        return window.open("/appDownload", "_blank");
      }
      this.$nextTick(() => {
        this.qrcode(id, text);
      });
    },
    // 生成二维码
    qrcode(id, text) {
      if (document.getElementById(id))
        document.getElementById(id).innerHTML = "";

      let qrcode = new QRCode(id, {
        width: 150,
        height: 150,
        text, // 二维码地址
        colorDark: "#000",
        colorLight: "#fff"
      });
    },
    handleScroll() {
      // 实现当滚动到指定位置，触发动画
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;

      let element = document.getElementById("home-download");

      var eTop = element.offsetTop; //橙色容器距离整个页面顶部的距离
      var wTop = windowHeight; //绿色框可视区域的高度

      if (wTop + scrollTop - 200 > eTop) {
        this.animation = true;
      }
    },
    goApp() {
      let routeData = this.$router.resolve({
        path: "/appDownload"
      });
      window.open(routeData.href, "_blank");
    },

    // 单元格点击
    handle(row, column, event, cell) {
      console.log(row, column, event, cell);
    }
  }
};
</script>

<style lang="less" scoped>
// .imgIcon{
//   width: 70px; height: 50px; background: url(/static/assets/ico/twitter_fave.png) no-repeat; background-position: 0 0;
// }
// .imgIcons{
//   background-position: -3519px 0; transition: background 1s steps(55);
// }
// 自定义模式
.custom {
  display: flex;
  align-items: center;

  .custom-main {
    margin-right: 5px;
    display: flex;
    align-items: center;
    white-space: nowrap;

    .custom-menu {
      margin-right: 5px;
    }
  }
}

.el-tag.el-tag--success {
  background-color: rgba(19, 184, 135, 0.15);
}

.el-tag.el-tag--danger {
  background-color: rgba(235, 77, 92, 0.15);
}

.exchange-pc {
  position: relative;
  width: 600px;
  margin-right: 40px;
}

@keyframes slideup {
  0% {
    -webkit-transform: translateY(20%);
    transform: translateY(20%);
  }

  to {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}

@keyframes slidedown {
  0% {
    -webkit-transform: translateY(-20%);
    transform: translateY(-20%);
  }

  to {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}

.home-download .img {
  width: 260px;
}

.animation_up {
  transition: all 0.8s ease-out 0.3s;
  animation: ease slideup 1s;
}

.animation_down {
  transition: all 0.8s ease-out 0.3s;
  animation: ease slidedown 1s;
}

// 首页下载
.home-download {
  background-color: #f5f7fb;
  height: 500px;
  overflow: hidden;

  // height: 700px;
  .home-download-title {
    text-align: center;
    font-size: 45px;
    font-weight: bold;
    margin: 10px 0;
  }

  .home-download-main {
    display: flex;
    margin-top: 30px;
    min-height: 400px;

    .download {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .download-left-main {
        flex: 1;

        .download-icon {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background-color: #02aff1;
          display: inline-block;
        }

        .download-app-title {
          font-size: 30px;
          display: inline-block;
        }

        .download-content {
          font-size: 20px;
          margin: 20px 0 30px 23px;
        }

        .download-btn-group {
          button {
            width: 130px;
            margin: 10px;
            height: 40px;
            // background: transparent;
          }
        }
      }

      .download-right-main {
        flex: 1;

        .download-icon {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background-color: #02aff1;
          display: inline-block;
        }

        .download-app-title {
          font-size: 30px;
          display: inline-block;
        }

        .download-content {
          font-size: 20px;
          margin: 20px 0 30px 23px;
        }

        .download-btn-group {
          button {
            width: 130px;
            margin: 10px;
            height: 40px;
            // background: transparent;
          }
        }
      }
    }

    .download.download-right {
      flex-direction: row-reverse;
    }

    .download-right {
      flex: 1;
      // background-color: bule;
      height: 100%;
    }
  }
}

.home_main {
  box-shadow: 0 0 42px 0 rgba(9, 30, 55, 0.06);
  padding: 20px 10px;
  margin-bottom: 30px;
  margin-top: 30px;
  min-height: 300px;
  /*min-width: 1080px;*/
  /*white-space: nowrap;*/
  /*overflow: hidden;*/

  /deep/ .el-table .cell {
    padding: 0 5px;
  }

  /deep/ tr.cell_style {
    cursor: pointer !important;
  }
}

.iconCoin {
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: sub;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
}

.At_the_bottom {
  // background-color: #fff !important;
}

.carousel {
  background: #101929 linear-gradient(336deg, #142547 0, #101929 100%);
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.coin-app {
  background-color: rgba(13, 14, 14, 0.75);
  padding: 10px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}

.app-info p {
  margin: 0;
  padding: 4px 0;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.app-info {
  line-height: 1.5;
  color: #fff;
  font-size: 14px;
  text-align: left;
}

.app-btn {
  margin-top: 20px;
}

.app-close {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
  background-color: #409eff;
  text-align: center;
  color: #fff;
  position: absolute;
  top: -12px;
  right: 15px;
  z-index: 1000;
  cursor: pointer;
}

.app-info .logo {
  width: 50px;
  height: 50px;
  padding: 5px;
  // background: url("/images/mobile/mobileBg.png")center center no-repeat;
  background-size: 100%;
  overflow: hidden;
  float: left;
  border-radius: 10px;
  box-shadow: 0 5px 5px #333;
  margin-right: 10px;
  background: linear-gradient(180deg, #02aff1, #0268fd);

  .app-logo {
    width: 100%;
    height: 100%;
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/views/home/home.vue